import React ,{useState, useEffect, useRef, useReducer} from 'react';
import { Row,  Form, Button } from 'react-bootstrap'; // Importing Row component from react-bootstrap
import Col from './Components/Col2.js';
import './bootstrap-scoped.scss';
import './FormCompnent.scss';
import * as FormActions from './Actions/FormActions.js'; 
import Busy from './Components/Busy.js';
import SignatureCanvas from 'react-signature-canvas'; // Importing the SignatureCanvas component

import nchLogo from './nchLogo.png'; // Importing the logo image
import nchLogoStacked from './nchLogoStacked.png'; // Importing the stacked logo image
import {FieldTypes, initialState} from './Constants/Constants.js'; // Importing field types constants
import {getValidationMessage } from './ValidationFunctions.js'; // Importing validation message function
import FormCell from './Components/FieldTypes/FormCell.js'; 
import NchLogoInline from './Components/FieldTypes/NchLogoInline.js';
import NchLogoBlock from './Components/FieldTypes/NchLogoBlock.js';
import NchLogoStackedInLine from './Components/FieldTypes/NchLogoStackedInLine.js';
import NchLogoStackedBlock from './Components/FieldTypes/NchLogoStackedBlock.js';
import CheckBoxBlock from './Components/FieldTypes/CheckBoxBlock.js';
import CheckBoxInline from './Components/FieldTypes/CheckBoxInLine.js';
import DropdownBlock from './Components/FieldTypes/DropdownBlock.js';
import DropdownInLine from './Components/FieldTypes/DropdownInLine.js';
import TextBlock from './Components/FieldTypes/TextBlock.js';
import TextInLine from './Components/FieldTypes/TextInLine.js';
import TextAreaBlock from './Components/FieldTypes/TextAreaBlock.js';
import TextAreaInLine from './Components/FieldTypes/TextAreaInLine.js';
import StatementInline from './Components/FieldTypes/StatementInline.js';
import StatementBlock from './Components/FieldTypes/StatementBlock.js';
import TypeaheadBase from './Components/FieldTypes/FieldTypeBase/TypeAheadBase.js';
import ValidationSummary from './Components/ValidationSummary.js';
import HeadingInline from './Components/FieldTypes/HeadingInline.js';
import Date_mm_dd_yyyy_Block from './Components/FieldTypes/Date_mm_dd_yyyy_Block.js';
import Date_mm_dd_yyyy_Inline from './Components/FieldTypes/Date_mm_dd_yyyy_Inline.js';
import ConfirmationMessage from './ConfirmationMessage.js';
import {getPdfBlob, generatePdfFromElement} from './PdfFunctions.js'; // Importing the PDF functions
import  {formReducer, reducerActions} from './Reducers/FormReducer.js';
import ButtonControls from './Components/ButtonControls.js';

const FormCompnent = (props) => {

  //extract form id and appId from the dom element
  const domContainer = document
  .querySelector(`#${props.domId}`);
  const formId = domContainer.dataset.formid || null; //form id
  const appId = domContainer.dataset.appid || null; //app id

  
  const token = domContainer.dataset.token || null; //token
  const formDivId = `app${appId}form${formId}`;
  const originUrl = FormActions.GetOriginUrl(); //get the origin url for the form
  
  const [entityId,setEntityId]  = useState(domContainer.dataset.entityid || null); //
  const [failed, setFailed] = useState(false); //api failed flag
  
  const formRef = useRef(); //to pass to the validation summary
  const formDivRef = useRef(); //to pass to the pdf functions
  const signatureRefs = useRef([]); //ref to hold signature canvas references
  const fieldRefs = useRef({}); //refs for window function access to the fields
  
  const [state, dispatchState] = useReducer(formReducer, initialState);

  //on load
  //retrieve the form definition
  //load into state
  useEffect(() => {
     dispatchState({ type: reducerActions.SET_API_BUSY,  payload: { value: true } });
    //go get the form definition from the server as json and attatch it to the window object
    //functions can not be serialized as a regular get call would do.
    const script = document.createElement('script');

    //adding an id to the script tag to make it possible to load the data from the same server
    script.src = FormActions.GetScriptJsonUrl(token, appId, formId); 
    //console.log("script src = ", script.src);
    script.onload = () => {
      dispatchState({ type: reducerActions.FORM_SRC_RECEIVED});
      //setFormLoaded(true); // trigger the effect that processes the form definition
    }; 
    script.onerror = (error) => {
      console.error('An error occured loading the form', error);
      dispatchState({ type: reducerActions.SET_API_BUSY,  payload: { value: false } });
      setFailed(true); // set failed state if the script fails to load        
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up the script when the component unmounts
    };
  
  }, []);


  //load the form definition into state when ready
  useEffect(() => {
    if(state.formLoaded===true){
      //read the form definition from the window object
      
      var formConfigurationObjectName =`app${appId}form${formId}`;
      if(token){
        formConfigurationObjectName = `token-${token.toLowerCase()}`; 
      }
      //console.log("formConfigurationObjectName = ", formConfigurationObjectName);
      var formDefinition = window[formConfigurationObjectName]
      dispatchState({ 
        type: reducerActions.FORM_DEFINITION_RECEIVED, 
        payload: formDefinition,
        formObjectName: formConfigurationObjectName
       });
     
      //apply the form css to the page
      if(!(formDefinition.css === undefined || formDefinition.css === null || formDefinition.css === "")){
        const style = document.createElement('style'); 
        style.appendChild(document.createTextNode(formDefinition.css));
        document.head.appendChild(style);
      }
      
    }
  }, [state.formLoaded]); 
 
//the submit button was clicked, the reducer validated all controls.
//post, then show the confirmation message
useEffect(() => {
     const submitForm = async() =>{
      if (state.readyToSubmit) {
      const payload = await getPayload();     
      FormActions.PostForm(payload)
      .then((resp)=>{
        dispatchState({ type: reducerActions.SUBMIT_FINISHED });
      })
      .catch((resp)=>{
          dispatchState({ type: reducerActions.SUBMIT_FAILED });
      })
      .finally(()=>{
        dispatchState({ type: reducerActions.SET_API_BUSY, payload: { value: false } })
      });     
     }
    };
    submitForm();

  }, [state.readyToSubmit]); 


  //package up the forms values
  const getPayload = async () => {
    const formData = new FormData();
    
    //add form metadata to the form data
    formData.append("appId", state.formState.appId);
    formData.append("formId", state.formState.formId);  
    if(entityId) formData.append("entityId", entityId || "");  

    //loop throught form fields
    Object.keys(state.formState.fields).map((key, index) => {
               
      //add text fields to the form data
      if(state.formState.fields[key].fieldType === FieldTypes.Text ||
        state.formState.fields[key].fieldType === FieldTypes.Textarea ||
        state.formState.fields[key].fieldType === FieldTypes.Dropdown ||
        state.formState.fields[key].fieldType === FieldTypes.Email ||
        state.formState.fields[key].fieldType === FieldTypes.Typeahead   ||
        state.formState.fields[key].fieldType === FieldTypes.DateMMDDYYYY
       ) {
        formData.append(state.formState.fields[key].fieldId, state.formState.fields[key].fieldValue||"");
      }

      if(state.formState.fields[key].fieldType ==="checkbox" ) {
        formData.append(state.formState.fields[key].fieldId, state.formState.fields[key].fieldValue? "checked": "");
      }

      //add signature fields to the form data
      if(state.formState.fields[key].fieldType ==="mouseSignature"){
        const canvas = document.querySelector(`#mouseSignatureWrapper${key}`);
        const dataUrl = canvas.toDataURL('image/png');         
        const blob = dataURLToBlob(dataUrl);
        
       // View in browser (for debugging)
       // const previewUrl = URL.createObjectURL(blob);
       // window.open(previewUrl, '_blank'); // opens the image in a new tab
        
        formData.append(`file`, blob, `${state.formState.fields[key].fieldId}.png`);
      }
    
    });   
    
    //add the pdf to the form data
    const { pdf, restore } = await generatePdfFromElement(formDivRef.current);
    dispatchState({ type: reducerActions.PDF_GENERATED, payload: { value: pdf } });
    const pdfBlob = await  getPdfBlob(pdf, restore);
 

    const pdfFile =  new File([pdfBlob], 'form.pdf', { type: 'application/pdf' });
    formData.append(`file`, pdfFile);

  //  these lines will open the posted pdf in a new tab for troubleshooting.
  //  const pdfUrl = URL.createObjectURL(pdfBlob);
  //  window.open(pdfUrl, '_blank');

    return formData;
  };

  //converts a signature canvas to a blob to be added as a file to the form data
  const dataURLToBlob = (dataURL) => {    
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
  
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
  
    return new Blob([uInt8Array], { type: contentType });
  }

  //reset to default when the reset button is clicked
  const resetForm = () => {
    dispatchState({ type: reducerActions.RESET_FORM });   
  }
 
  //this prevents the form from submitting when the enter key is pressed
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  };


  
  if (failed) {
    return <div>An error occurred retrieving this form.</div>;
  } 
  if (!state.formState) {
    return <div>
       <Busy isBusy={state.apiBusy}></Busy>
       Loading...</div>;
  }

  return (
    <div className="form-wrapper">
     {state.showConfirmation && 
      (   
        <ConfirmationMessage
              state = {state}
              message = {state.formState.formConfirmationMessage}
              pdfBlob = {state.pdfBlob}
        />
      )}
    <Busy isBusy={state.apiBusy}></Busy>
    <Form noValidate  
      className={`${state.showConfirmation ? 'hidden' : ''}`}
      ref={formRef}
      validated={state.validated} 
      onKeyDown={handleKeyDown}
     >    

      <div ref = {formDivRef} className = "form" id = {formDivId} key= {formDivId}>
      
        <Row key="formfieldsrow">
      
          {Object.keys(state.formState.fields).map((key, index) =>{
            if (!fieldRefs.current[key]) {
              fieldRefs.current[key] = React.createRef();
            }
            return(

  //Form Page
          state.formState.fields[key].fieldType === FieldTypes.FormPage  && (
            
            <div key={key} id= {`page-${key}`}
              className={`page-wrapper ${key === state.activePage ? ' active-page' : 'inactive-page'}`}>

              <div //this is the page container where children are rendered
                id= {`${key}`}
                style={{ order: state.formState.fields[key].sort }}              
                className="page-container form-page row" > 
              </div>

            </div>
          ) ||

  //page-break
          state.formState.fields[key].fieldType === FieldTypes.PageBreak && (
           <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>        
            <div key={key}
              style={{ order: state.formState.fields[key].sort }}
              className="page-break"></div>
          </FormCell>
          ) ||

  //nch logo block
          state.formState.fields[key].fieldType === FieldTypes.NchLogo && !state.formState.fields[key]?.inLine && (
          <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>          
            <NchLogoBlock key = {key} 
              style={{ order: state.formState.fields[key].sort }}
              logourl = {originUrl+ nchLogo}
              field = {state.formState.fields[key]}/>
          </FormCell> 

          ) ||

  //nch logo inline
          state.formState.fields[key].fieldType === FieldTypes.NchLogo && state.formState.fields[key]?.inLine && (
          <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>   
            <NchLogoInline key={key}
              style={{ order: state.formState.fields[key].sort }}
              logourl = {originUrl + nchLogo}
              field={state.formState.fields[key]}/>
        </FormCell>
          ) ||

  //nchLogoStacked block
          state.formState.fields[key].fieldType === FieldTypes.NchLogoStacked && !state.formState.fields[key]?.inline && (
          
          <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>   
          
            <NchLogoStackedBlock key = {key} 
              style={{ order: state.formState.fields[key].sort }}
              logourl = {originUrl+ nchLogoStacked}
              field = {state.formState.fields[key]}/>   

          </FormCell>

          ) ||

  //nchLogoStacked inline
            state.formState.fields[key].fieldType === FieldTypes.NchLogoStacked && state.formState.fields[key]?.inline && (
                <FormCell 
                //the page control id or blank for root
                pageId = {state.formState.fields[key].containerId}
                key={"cell" + key}>   

                  <NchLogoStackedInLine key = {key}
                    style={{ order: state.formState.fields[key].sort }}
                    logourl = {originUrl+ nchLogoStacked}
                    field = {state.formState.fields[key]}/>   

                </FormCell>

            ) ||

  //formName
            state.formState.fields[key].fieldType === FieldTypes.FormName && (
              
            <FormCell 
              // the page control id or blank for root
              pageId = {state.formState.fields[key].containerId}
              key={"cell" + key}>   

              <Col style={{ order: state.formState.fields[key].sort }}
                className={` ${state.formState.fields[key].class || "" } col-md-${state.formState.fields[key].width}`}
                key={key} id={key}>
                  <h1 key={key+"h1"} >{state.formState.formName}</h1>
              </Col>

            </FormCell>

            ) ||

  // divider
            state.formState.fields[key].fieldType === FieldTypes.Divider && (
            <FormCell 
              // the page control id or blank for root
              pageId = {state.formState.fields[key].containerId}
              key={"cell" + key}>   

              <Col
                style={{ order: state.formState.fields[key].sort }}
                className={` ${state.formState.fields[key].class || ""} col-md-${state.formState.fields[key].width}`}
                key={key} id={key}>
                  <hr key = {key + "hr"}className = {`divider`}/>
              </Col>

            </FormCell>

            ) ||

  //paragraph
            state.formState.fields[key].fieldType === FieldTypes.Paragraph && (

              <FormCell 
                // the page control id or blank for root
                pageId = {state.formState.fields[key].containerId}
                key={"cell" + key}>   

                  <Col
                    style={{ order: state.formState.fields[key].sort }}
                    className={` ${state.formState.fields[key].class || ""} col-md-${state.formState.fields[key].width}`}
                    key={key} id={key}>
                      <p key={key + "p"} dangerouslySetInnerHTML = {{ __html: state.formState.fields[key].fieldValue }}>
                      </p>
                  </Col>
                
                </FormCell>
          ) ||

  // heading block
            state.formState.fields[key].fieldType === FieldTypes.Heading && !state.formState.fields[key].inLine && (
              
              <FormCell 
                // the page control id or blank for root
                pageId = {state.formState.fields[key].containerId}
                key={"cell" + key}>

                  <Col
                    style={{ order: state.formState.fields[key].sort }}
                    className={` ${state.formState.fields[key].class || ""} col-md-${state.formState.fields[key].width}`}
                    key={key} id={key}>
                      <h2 >{state.formState.fields[key].fieldValue}</h2>
                  </Col>

                </FormCell>

            ) ||

  // heading inline
            state.formState.fields[key].fieldType === FieldTypes.Heading && state.formState.fields[key].inLine && (
              
          
                <HeadingInline 
                  key={key}
                  style={{ order: state.formState.fields[key].sort }}
                  field={state.formState.fields[key]}
                  objectkey={key}
                  containerId={state.formState.fields[key].containerId || formDivId}/>

    

            ) ||

  //statement block
            state.formState.fields[key].fieldType === FieldTypes.Statement && !state.formState.fields[key].inLine && (
            
              <FormCell 
                // the page control id or blank for root
                pageId = {state.formState.fields[key].containerId}
                key={"cell" + key}>   

                <StatementBlock
                    key={key}
                    style={{ order: state.formState.fields[key].sort }}
                    field={state.formState.fields[key]}
                    objectkey= {key}
                    />

              </FormCell> 
          ) ||

  //statement inline
          state.formState.fields[key].fieldType === FieldTypes.Statement && state.formState.fields[key].inLine && (
           
              <StatementInline
                key={key}
                style={{ order: state.formState.fields[key].sort }}
                field={state.formState.fields[key]}
                objectkey={key}
                containerId={state.formState.fields[key].containerId || formDivId}
              />
            
          ) ||
          
  //mouse signature
          state.formState.fields[key].fieldType === FieldTypes.MouseSignature && (

            <FormCell
              // the page control id or blank for root
              pageId = {state.formState.fields[key].containerId}
              key={"cell" + key}>

                <Col
                  style={{ order: state.formState.fields[key].sort }}
                  className={` ${state.formState.fields[key].class} col-md-${state.formState.fields[key].width} field mouseSignatureWrapper`}
                  key={key} id={key}>
                    
                    <label key = {key + "label"}>
                      {state.formState.fields[key].fieldLabel || state.formState.fields[key].fieldName}
                    </label>
                  
                    <SignatureCanvas 
                      key = {key + "signatureCanvas"}
                      canvasProps={
                        { className: "mouseSignature",
                          id : `mouseSignatureWrapper${key}`
                        }
                      } 
                      ref = {el => (signatureRefs.current[index] = el)} />
                </Col>

              </FormCell>
          ) ||
          
//dropdown block 
          state.formState.fields[key].fieldType === FieldTypes.Dropdown && !state.formState.fields[key].inLine &&(
          <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>          
              
              <DropdownBlock 
                field = {state.formState.fields[key]}
                objectkey = {key} 
                options = {window[state.formObjectName].lists[state.formState.fields[key].options] || []  }
                dispatchState = {dispatchState} 
                touched =   {state.formState.fields[key].isTouched}
                error = {state.formState.fields[key]?.error||""}
                style={{ order: state.formState.fields[key].sort }}
              />

          </FormCell> 

          ) ||

  //dropdown inline
          state.formState.fields[key].fieldType === FieldTypes.Dropdown && state.formState.fields[key].inLine &&(

            <DropdownInLine
              containerId = {state.formState.fields[key].containerId}
              key = {key}
              field = {state.formState.fields[key]}
              options = {state.formState.fields[key].options || []  }
              objectkey = {key} 
              dispatchState = {dispatchState} 
              touched =   {state.formState.fields[key].isTouched}
              error = {state.formState.fields[key]?.error||""}
              style={{ order: state.formState.fields[key].sort }}
            />
    
          ) ||

  //text box Block
          state.formState.fields[key].fieldType === FieldTypes.Text && !state.formState.fields[key].inLine &&(
          <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>          
              
              <TextBlock 
                field = {state.formState.fields[key]}
                objectkey = {key} 
                dispatchState = {dispatchState} 
                touched =   {state.formState.fields[key].isTouched}
                error = {state.formState.fields[key]?.error||""}
                style={{ order: state.formState.fields[key].sort }}
              />

          </FormCell> 

          ) ||

  //text box InLine
          state.formState.fields[key].fieldType === FieldTypes.Text && state.formState.fields[key].inLine &&(

            <TextInLine
              containerId = {state.formState.fields[key].containerId}
              key = {key}
              field = {state.formState.fields[key]}
              objectkey = {key} 
              dispatchState = {dispatchState} 
              touched =   {state.formState.fields[key].isTouched}
              error = {state.formState.fields[key]?.error||""}
              style={{ order: state.formState.fields[key].sort }}
            />
    
          ) ||

  //text area Block
          state.formState.fields[key].fieldType === FieldTypes.Textarea && !state.formState.fields[key].inLine &&(

          <FormCell 
            //the page control id or blank for root
            pageId = {state.formState.fields[key].containerId}
            key={"cell" + key}>

              <TextAreaBlock
                field = {state.formState.fields[key]}
                objectkey = {key} 
                dispatchState = {dispatchState} 
                touched =   {state.formState.fields[key].isTouched}
                error = {state.formState.fields[key]?.error||""}
                style={{ order: state.formState.fields[key].sort }}
              />

            </FormCell>
          ) ||

  //text area InLine
          state.formState.fields[key].fieldType === FieldTypes.Textarea && state.formState.fields[key].inLine &&(

                
                <TextAreaInLine                
                  key={key} 
                  field = {state.formState.fields[key]}
                  objectkey = {key} 
                  dispatchState = {dispatchState} 
                  touched =   {state.formState.fields[key].isTouched}
                  error = {state.formState.fields[key]?.error||""}
                  style={{ order: state.formState.fields[key].sort }}
                />

        
          ) ||

  //check box block         
          state.formState.fields[key].fieldType === FieldTypes.Checkbox && !state.formState.fields[key]?.inLine && (
            <FormCell 
              //the page control id or blank for root
              pageId = {state.formState.fields[key].containerId}
              key={"cell" + key}>

                <CheckBoxBlock
                  field = {state.formState.fields[key]}
                  objectkey = {key} 
                  dispatchState = {dispatchState} 
                  touched =   {state.formState.fields[key].isTouched}
                  error = {state.formState.fields[key]?.error||""}
                  style={{ order: state.formState.fields[key].sort }}
                />

              </FormCell>

            ) ||

  //check box inline   
        state.formState.fields[key].fieldType === FieldTypes.Checkbox && state.formState.fields[key]?.inLine && (
      
              <CheckBoxInline
                key={key}
                field = {state.formState.fields[key]}
                  objectkey = {key} 
                  dispatchState = {dispatchState} 
                  touched =   {state.formState.fields[key].isTouched}
                  error = {state.formState.fields[key]?.error||""}
                  style={{ order: state.formState.fields[key].sort }}
              />
      
        ) ||

    //typeAhead    
            state.formState.fields[key].fieldType === FieldTypes.Typeahead && (
              <FormCell 
                //the page control id or blank for root
                pageId = {state.formState.fields[key].containerId}
                key={"cell" + key}>

                  <Col
                    style={{ order: state.formState.fields[key].sort }}
                    key={key}
                    className={`col-md-${state.formState.fields[key].width} field typeahead ${state.formState.fields[key].class}`}>

                      <TypeaheadBase
                          field = {state.formState.fields[key]}
                          objectkey = {key}
                          dispatchState = {dispatchState}
                          touched =   {state.formState.fields[key].isTouched}
                          error = {state.formState.fields[key]?.error||""}
                          style={{ order: state.formState.fields[key].sort }}
                          key={key+ "typeahead"}
                          placeholder = "Choose..."
                          options={state.formState.lists[state.formState.fields[key].options]}
                          newSelectionPrefix="&nbsp;"                                                            
                      />
                    
                  </Col>   

                </FormCell>     
            ) ||

  //Container           
            state.formState.fields[key].fieldType === FieldTypes.Container && (

              <FormCell 
                  //the page control id or blank for root
                  pageId = {state.formState.fields[key].containerId}
                  key={"cell" + key}>
            
                      <Col
                        style={{ order: state.formState.fields[key].sort }}
                        id= {`field${state.formState.fields[key].fieldId}`}
                        key={key}
                        className={`col-md-${state.formState.fields[key].width} container  ${state.formState.fields[key].class || ""}`}>
                      </Col>

                </FormCell>
            ) ||

    //date mm-dd-yyyy  Block
          state.formState.fields[key].fieldType === FieldTypes.DateMMDDYYYY && !state.formState.fields[key]?.inLine && (

            <FormCell
              pageId = {state.formState.fields[key].containerId}
              key={"cell" + key}>

              <Date_mm_dd_yyyy_Block
                field = {state.formState.fields[key]}            
                objectkey = {key} 
                dispatchState = {dispatchState} 
                style={{ order: state.formState.fields[key].sort }}              
              />  

            </FormCell>

          ) ||                    
  
  //date mm-dd-yyyy  Inline
          state.formState.fields[key].fieldType === FieldTypes.DateMMDDYYYY && state.formState.fields[key].inLine && (

              <Date_mm_dd_yyyy_Inline  
                key={key}               
                field = {state.formState.fields[key]}            
                objectkey = {key} 
                dispatchState = {dispatchState} 
                style={{ order: state.formState.fields[key].sort }}  
                containerId = {state.formState.fields[key].containerId || formDivId}/>

          ) ||

            //email text boxes  
            state.formState.fields[key].fieldType === FieldTypes.Email && (
              <></>
            // TODO

            ));
          })}

        </Row>
          
      </div>  

        <ValidationSummary
          formState={state.formState}        
        />

     {state.formLoaded === true  && (
        <ButtonControls 
          state = {state}
          dispatchState = {dispatchState}    
        />
      )}
      
      </Form>
    </div>
  );
};

export default FormCompnent;
